export const API_URL = 'https://api.gov.sama.live';
// export const API_URL = 'http://localhost:9072';
export const API_ENDPOINT_PREFIX  =  'api';
export const API_VERSION = 'v1';
export const API_BASE_URL = `${API_URL}/${API_ENDPOINT_PREFIX}/${API_VERSION}`;
export const VIKALP_API_URL = "https://vikalp.sama.live"
export const VIKALP_API_KEY = "687yzW2iB5w7988C278KaUQp4Bf7QbHK"